export function removeDiacriticsFromString(text: string): string {
  const txt = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  return txt;
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/misc/remove-diacritics-from-string.ts